import { FieldType, Operator } from '../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';
import ComparisonValue from './ComparisonValue';
import SetValue from './SetValue';
import NullValue from './NullValue';
import BetweenValue from './BetweenValue';
import DateCriterionValue from '../dateCriterionValue';

const NumericValue = ({
  selectedOperator,
  selectedFieldSubType,
  fieldName,
  showLabel,
  availableValueOptions,
  readOnly = false
}) => {
  if (selectedFieldSubType === FieldType.DATE) {
    return (
      <DateCriterionValue
        selectedOperator={selectedOperator}
        fieldName={fieldName}
        showLabel={showLabel}
        readOnly={readOnly}
      />
    )
  } else {
    switch (selectedOperator) {
      case Operator.EQUAL:
      case Operator.NOT_EQUAL:
        return (
          <EqualValue
            availableValueOptions={availableValueOptions}
            fieldName={fieldName}
            showLabel={showLabel}
            readOnly={readOnly}
          />
        );
      case Operator.GREATER_THAN:
      case Operator.GREATER_OR_EQUAL:
      case Operator.LESS_THAN:
      case Operator.LESS_OR_EQUAL:
        return <ComparisonValue showLabel={showLabel} fieldName={fieldName} readOnly={readOnly}/>;
      case Operator.BETWEEN:
        return <BetweenValue/>;
      case Operator.IS_NULL:
      case Operator.NOT_NULL:
        return <NullValue/>;
      case Operator.IN_SET:
      case Operator.NOT_IN_SET:
        return (
          <SetValue
            fieldName={fieldName}
            showLabel={showLabel}
            availableValueOptions={availableValueOptions}
            readOnly={readOnly}
          />
        );
      default:
        return <></>;
    }
  }
};

export default NumericValue;
